// Validators
export const RESERVED_ROLE_NAMES = [
    { value: 0, name: 'developer' },
    { value: 1, name: 'ftpuser' },
    { value: 2, name: 'sysadmin' },
    { value: 3, name: 'user' },
    { value: 4, name: 'admin' },
    { value: 5, name: 'admins' },
    { value: 6, name: 'applications' },
    { value: 7, name: 'config_handler' },
    { value: 8, name: 'database_manager' },
    { value: 9, name: 'imthandler' },
    { value: 10, name: 'ni_accesshandler' },
    { value: 11, name: 'ni_assignmenthandler' },
    { value: 12, name: 'ni_cardserver' },
    { value: 13, name: 'ni_checkinhandler' },
    { value: 14, name: 'ni_config_handler' },
    { value: 15, name: 'ni_dutyhandler' },
    { value: 16, name: 'ni_eventhandler' },
    { value: 17, name: 'ni_fallbackhandler' },
    { value: 18, name: 'ni_forwardinghandler' },
    { value: 19, name: 'ni_linkinghandler' },
    { value: 20, name: 'ni_locationserver' },
    { value: 21, name: 'ni_locationstatushandler' },
    { value: 22, name: 'nurses' },
    { value: 23, name: 'postgres' },
    { value: 24, name: 'rf_device_manager' },
    { value: 25, name: 'roomcontroller_dh' },
    { value: 26, name: 'sal' },
    { value: 27, name: 'task_handler' },
    { value: 28, name: 'una' },
    { value: 29, name: 'uns' },
    { value: 30, name: 'uus' },
    { value: 31, name: 'tcm_bridge' },
    { value: 32, name: 'textdisplaycsi' },
    { value: 33, name: 'superuser' },
];
export const MAX_NAME_LENGTH = 24;
export const MAX_COMMENT_LENGTH = 300;
export const MAX_DESCRIPTION_LENGTH = 128;
export const MAX_REPORT_NAME_LENGTH = 50;
export const MAX_PASSWORD_LENGTH = 24;
export const MAX_CALL_NAME_LENGTH = 10;
export const MAX_MEMBERS_LIST = 8;
export const MAX_EMAILS = 10;
export const ASSIGNMENTS_MAX_LENGTH = 16;
export const ASSIGNMENTS_ROOMS_PER_PAGE = 20;
export const MAX_PHONE_LENGTH = 15;
export const DIGITS_CHAR_CODES = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
export const MAX_TIMEOUT = 99999;
export const MIN_TIMEOUT = 1;
export const MAX_STAFF_OVERLOAD = 99999;
export const MIN_STAFF_OVERLOAD = 1;
export const STAFF_MEMBERS_NAVIGATION_NUMBER = 20;
export const AUDIT_TRAIL__ROOM_CONF_NAVIGATION_NUMBER = 20;

// Dashboard, WidgetConfigurator
export const WIDGET_TYPES = Object.freeze({
    Loader: -1,
    SystemActivity: 1,
    StaffPerformance: 2,
    TargetTime: 3,
    NursePresence: 4,
    RecentEvents: 5,
    ExceptionTime: 6,
    AverageTime: 7,
    Assignments: 8,
});

export const AUTOREFRESH_INTERVAL = 10 * 60 * 1000; // 10 minutes
export const DEBOUNCE_INTERVAL = 150;
export const DEBOUNCE_SEARCH = 350;
export const DEBOUNCE_CHARTS_REFRESH = 700;

export const BACKUP_FILE_TYPES = ['fbak'];

export const WIDGET_SETTINGS = {
    HEIGHT: 460,
    COLUMN_BREAKPOINTS: [964, 1550],
};

// Reports
export const REPORT_TYPES = {
    LOCATION: 1,
    FULL_EVENT: 2,
    ASCOM_EVENT: 3,
    PAIR_EVENT: 4,
    EXCEPTION: 5,
    STAFF_PERFORMANCE: 6,
};
export const EVENT_PAIR_TYPES = [
    { value: 1, name: 'Call set -> Call canceled' },
    { value: 3, name: 'Call set -> Nurse presence on' },
    { value: 4, name: 'Call set -> Call accepted' },
    { value: 5, name: 'Call accepted -> Call canceled' },
    { value: 6, name: 'Nurse presence on -> Nurse presence off' },
    { value: 7, name: 'Message sent to portable -> Call accepted' },
    { value: 8, name: 'Message sent to portable -> Call rejected' },
    { value: 9, name: 'Speech connection -> Speech connection terminated' },
    { value: 10, name: 'Card sign in -> Card sign out' },
];
export const SCHEDULER_PERIODS = {
    DAILY: 1,
    WEEKLY: 7,
    BIWEEKLY: 14,
    MONTHLY: 30,
};
export const DATE_LENGHT = 10;
export const TIME_LENGHT = 5;
export const DEFAULT_TIME_FROM = '00:00';
export const DEFAULT_TIME_TO = '23:59';
// DatePicker
export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export const SHORTWEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const TABLE_HEADER_HEIGHT = 70;
// SelectBox: Drop down List
export const DEFAULT_OPTION_HEIGHT_DDLIST = 41;
export const MAX_ELEMENTS_DDLIST = 6;

// Pagination
export const OFFSET = 2;

// Room Configuration: Maximum modules in each request for saving
// Value can be changed by decreasing or increasing hardware performance
export const MAX_MODULES = 50;

// Assignments: Staff selection menu
export const DEFAULT_OPTION_HEIGHT_SSMENU = 31;
export const MAX_ELEMENTS_SSMENU = 10;
export const LOCATIONS_FOR_SAVE_NUMBER = 5;
export const MAX_PHONES_FOR_SAVE = 512;

// AcousticSettings
export const MIN_SOUND_LEVEL = 0;
export const MAX_SOUND_LEVEL = 100;
export const ACTIVATION_TIME_FROM = 100;
export const ACTIVATION_TIME_TO = 3000;

// AccessGroups
export const DEFAULT_DELAY = 30;
export const MIN_DELAY_DURATION = 30;
export const MAX_DELAY_DURATION = 600;
export const DEFAULT_DURATION = 120;

// Popup
export const UNKNOWN_ERROR = 'Unknown error';
export const SUCCESS = 'success';
export const ERROR = 'error';

// Component names
export const COMPONENT_NAMES = {
    DAY_SELECTOR: 'DaySelector',
    HEADER_VIEW: 'HeaderView',
    LOADING_BLOCK: 'LoadingBlock',
    PANEL: 'Panel',
    ROOM_SETTINGS: 'RoomSettings',
    ROOM_SETTINGS_PANEL: 'RoomSettingsPanel',
    SCHEDULERS: 'Schedulers',
    WANDER_MANAGEMENT: 'WanderManagement',
};

// Route names
export const ROUTE_NAMES = {
    ASSIGNMENTS: 'assignments',
    AUDIT_TRAIL: 'auditTrail',
    AUDIT_TRAIL__LOG_IN: 'auditTrail.logIn',
    AUDIT_TRAIL__ROOM_CONFIGURATION: 'auditTrail.roomConfiguration',
    CHECK_IN: 'checkIn',
    CHECK_IN__NOT_CHECKED_IN: 'checkIn.notCheckedIn',
    CHECK_IN__RESIDENT_CHECK_IN: 'checkIn.residentCheckIn',
    DASHBOARD: 'dashboard',
    DUTY_SELECTOR: 'dutySelector',
    ERROR_404: 'error404',
    EXTERNAL: 'external',
    MAINTENANCE: 'maintenance',
    NOT_CHECKED_IN: 'notCheckIn',
    NOT_CHECKED_IN__NOT_CHECKED_IN_FULL: 'notCheckIn.notCheckedInFull',
    NOT_CHECKED_IN__REPORT_CONFIGURATION: 'notCheckIn.reportConfiguration',
    REPORTS: 'reports',
    REPORTS__CUSTOM: 'reports.custom',
    REPORTS__CUSTOM__EDIT: 'reports.custom.edit',
    REPORTS__EDIT: 'reports.edit',
    REPORTS__SHOW: 'reports.show',
    ROOM_CONFIGURATION: 'roomConfiguration',
    ROOM_SETTINGS: 'roomSettings',
    SENSORS: 'sensors',
    SENSORS__ROOM_PROFILES: 'sensors.roomProfiles',
    SENSORS__RESIDENT_PROFILES: 'sensors.residentProfiles',
    SENSORS__RESIDENT_PROFILES__ADD: 'sensors.residentProfiles.add',
    SENSORS__RESIDENT_PROFILES__EDIT: 'sensors.residentProfiles.edit',
    SETTINGS: 'settings',
    SETTINGS__ASSIGNMENTS_CONF: 'settings.assignmentsConf',
    SETTINGS__AUTO_LOGOUT: 'settings.autoLogout',
    SETTINGS__COLOR_SCHEME: 'settings.colorScheme',
    SETTINGS__ORGANIZATION: 'settings.organization',
    SETTINGS__TARGET_TIME: 'settings.targetTime',
    SETTINGS__LOG_SETTINGS: 'settings.logSettings',
    SETTINGS__TAB_VISIBILITY: 'settings.tabVisibility',
    SETTINGS__OTHER: 'settings.other',
    SUPER_USERS: 'superUsers',
    STAFF: 'staff',
    STAFF__GROUPS: 'staff.groups',
    STAFF__MEMBERS: 'staff.members',
    WANDER_MANAGEMENT: 'wanderManagement',
    WANDER_MANAGEMENT__ACCESS_GROUPS: 'wanderManagement.accessGroups',
    WANDER_MANAGEMENT__ACCESS_GROUPS__ADD: 'wanderManagement.accessGroups.add',
    WANDER_MANAGEMENT__ACCESS_GROUPS__EDIT: 'wanderManagement.accessGroups.edit',
    WANDER_MANAGEMENT__SCHEDULERS: 'wanderManagement.schedulers',
    WANDER_MANAGEMENT__SCHEDULERS__ADD: 'wanderManagement.schedulers.add',
    WANDER_MANAGEMENT__SCHEDULERS__EDIT: 'wanderManagement.schedulers.edit',
    WIRELESS_MODULES: 'wirelessModules',
    WIRELESS_MODULES__ADD: 'wirelessModules.add',
    WIRELESS_MODULES__EDIT: 'wirelessModules.edit',
    WIRELESS_SPEECH: 'wirelessSpeech',
};

// User
export const AUTH_COOKIE = 'cc';
export const SESSION_ID_COOKIE = 'cd';
export const USER_TYPES = {
    DEVELOPER: 0,
    SYS_ADMIN: 1,
    USER_ADMIN: 3,
    USER: 4,
    SUPER_USER: 5,
};

// Audit Trail
export const AUDIT_TRAIL = {
    FILTER_BY: {
        ALL: 1,
        ONLINE: 2,
        OFFLINE: 3,
        EXISTING: 4,
        DELETED: 5,
    },
    PAGE_SIZE: 10,
    DATE_RANGE: {
        DAY: 1,
        WEEK: 7,
        MONTH: 30,
        YEAR: 365,
    },
    RECORDS_LIMIT: 1000,
};

// Key codes
export const KEYS = {
    ENTER: 13,
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
};

// The list can be extended
export const EVENT_KEYS = {
    CALL: 'call',
    CALL_ACCEPTED: 'callAccepted',
    NURSE_PRESENT: 'nursePresent',
    NURSE_PRESENT_CANCEL: 'nursePresentCancel',
    CALL_SPEECH: 'callSpeech',
    CALL_PARKED: 'callParked',
    CALL_REJECTED: 'callRejected',
};

// Time formats
export const DATE_FORMATS = [
    { date: 'yyyy-MM-dd', separator: ' / ', php_date: 'Y-m-d' },
    { date: 'MM/dd/yyyy', separator: ' ', php_date: 'm/d/Y' },
];
export const TIME_FORMATS = [
    { time: 'HH:mm:ss', php_time: 'H:i:s' },
    { time: 'hh:mm:ss aa', php_time: 'h:i:s A' },
];
export const DEF_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const DEF_TIME_FORMAT = 'hh:mm:ss';

// ProgressBar
export const PROGRESS_BAR_SHOW_START_LIMIT = 7; // in seconds

// Room Configuration buttons visibility
export const BUTTONS_VISIBILITY = {
    TO_ALL: 0, // The buttons are available to all
    TO_NONE: 1, // The buttons are available to none
    TO_SU: 2, // The buttons are available to super users and user administrators
};

// Cards
export const CARD_ID_LENGTHS = {
    MIFARE_CLASSIC: 2 * 5, // 5 bytes, or 10 symbols
    MIFARE_ULTRALIGHT_DESFIRE: 2 * 7, // Mifare Ultraligh and Mifare Desfire
    WIEGAND: 2 * 4,
};
export const CARD_ID_LENGTHS_ARRAY = Object.values(CARD_ID_LENGTHS).sort((a, b) => a - b);
export const CARD_ID_LENGTHS_BUT_LAST_ONE = CARD_ID_LENGTHS_ARRAY.slice(0, -1).join(', '); // String, all lenghts but the last one
export const CARD_ID_LAST_ALLOWED_LENGTH = CARD_ID_LENGTHS_ARRAY.slice(-1); // The last of allowed lenghts
export const CARD_LEVEL_ANONYMOUS_VALUE = 255;
export const CARD_LEVEL_START_VALUE = 120;
export const CARD_LEVELS_NUMBER = 10;
export const DEFINED_CARD_LEVEL_VALUES = [...Array(CARD_LEVELS_NUMBER).keys()]
    .map(level => level + CARD_LEVEL_START_VALUE)
    .concat([CARD_LEVEL_ANONYMOUS_VALUE]);

export const MAX_AUDIT_TRAIL_EVENTS = 250000;
export const MAX_ROOM_HISTORY_EVENTS = 250000;
